// @flow
import { createSelector } from 'reselect';
import { MOUNT_POINT } from './constants';
import type { State, AlertDialog, ConfirmDialog } from './reducer';
import type { State as WFState } from '../reducer';
import getWorkflowState from '../selectors';

export const getDialogsState: (state: WFState) => State = createSelector(
    getWorkflowState, (state) => state[MOUNT_POINT],
);

export const getAlerts: (state: State) => Array<AlertDialog> = createSelector(getDialogsState, (state) => state.alerts);
export const getConfirms: (state: State) => Array<ConfirmDialog> = createSelector(
    getDialogsState, (state) => state.confirms,
);
